import SettingsLayout from "../Layout";

import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';

// Tabs
import GeneralTab from "./Tabs/General";


  const tabContent = [
    {panel: "general", content: <GeneralTab />},
  ]

const ImportSettings = () => {

  const tabs = [
    {label: "General", icon: <ReceiptLongRoundedIcon fontSize="small" />},
  ];

  return (
    <SettingsLayout title="Import Data" identifier="invoice_id" tabs={tabs} tabContent={tabContent} url="settings/import">

    </SettingsLayout>
  )
};

export default ImportSettings;